import { render, staticRenderFns } from "./ItemModal.vue?vue&type=template&id=10fbf0b1"
import script from "./ItemModal.vue?vue&type=script&lang=js"
export * from "./ItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10fbf0b1')) {
      api.createRecord('10fbf0b1', component.options)
    } else {
      api.reload('10fbf0b1', component.options)
    }
    module.hot.accept("./ItemModal.vue?vue&type=template&id=10fbf0b1", function () {
      api.rerender('10fbf0b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/ItemModal.vue"
export default component.exports